import React, { useState } from "react";
import { Button, Typography, Box } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import VisuallyHiddenInput from "../VisuallyHiddenInput";

const UploadSubtitleFile = ({
	formik,
	subtitleFile,
	setSubtitleFile,
	name,
}) => {
	const [subtitleContent, setSubtitleContent] = useState("");

	// const handleSubtitleFileChange = (event) => {
	// 	const file = event.target.files[0];
	// 	if (file && file.name.endsWith(".srt")) {
	// 		const filePath = `${formik.values.type.replace(
	// 			/\s+/g,
	// 			""
	// 		)}/${formik.values.category.replace(
	// 			/\s+/g,
	// 			""
	// 		)}/${formik.values.title.replace(
	// 			/\s+/g,
	// 			""
	// 		)}/subtitles/${formik.values?.title
	// 			.replace(/\s+/g, "")
	// 			.toLowerCase()}-${formik?.values?.language}.srt`;

	// 		// Read the content of the subtitle file
	// 		const reader = new FileReader();
	// 		reader.onload = (e) => {
	// 			setSubtitleContent(e.target.result);
	// 		};
	// 		reader.readAsText(file);
	// 		console.log(file, "subtitleFile");
	// 		setSubtitleFile((prevState) => {
	// 			return {
	// 				...prevState,
	// 				subtitleFile: file,
	// 				subtitleFilePath: filePath,
	// 			};
	// 		});
	// 	} else {
	// 		toast.error("Invalid File Selected! Only .srt files are allowed.");
	// 		event.target.value = ""; // Clear the input
	// 	}
	// };

	const handleSubtitleFileChange = (event) => {
		const file = event.target.files[0];
		if (!file || !file.name.endsWith(".srt")) {
			toast.error("Invalid File Selected! Only .srt files are allowed.");
			event.target.value = ""; // Clear the input
			return;
		}

		const sanitizeString = (str) => {
			// Replace any character that isn't a-z, A-Z, 0-9, hyphen, underscore, or period
			return str.replace(/[^a-zA-Z0-9-_.]/g, "");
		};

		const filePath = `${sanitizeString(
			formik.values.type
		)}/${sanitizeString(
			formik.values.category
		)}/${formik.values.title.replace(
			/\s+/g,
			""
		)}/subtitles/${sanitizeString(formik.values.title).toLowerCase()}-${
			formik.values.language
		}.srt`;

		// Read the content of the subtitle file
		const reader = new FileReader();
		reader.onload = (e) => {
			setSubtitleContent(e.target.result);
		};
		reader.readAsText(file);

		console.log(file, "subtitleFile");
		setSubtitleFile((prevState) => ({
			...prevState,
			subtitleFile: file,
			subtitleFilePath: filePath,
		}));
	};

	const handleRemoveSubtitleFile = () => {
		setSubtitleFile((prevState) => {
			return {
				...prevState,
				subtitleFile: "",
				subtitleFilePath: "",
			};
		});
		setSubtitleContent(""); // Clear the preview content
	};

	return (
		<Box>
			{subtitleFile ? (
				<>
					<h3>Uploaded Subtitle File</h3>
					<div
						style={{
							position: "relative",
							marginBottom: "10px",
							overflow: "hidden",
						}}
					>
						<Typography>{subtitleFile.name}</Typography>
						<button
							onClick={handleRemoveSubtitleFile}
							style={{
								position: "absolute",
								top: "5px",
								right: "5px",
								border: "none",
								backgroundColor: "rgba(255,0,0,0.6)",
								borderRadius: "50%",
								cursor: "pointer",
							}}
						>
							<DeleteIcon style={{ color: "white" }} />
						</button>
					</div>
					<Box mt={2}>
						<Typography variant="h6">Subtitle Preview:</Typography>
						<Box
							sx={{
								height: "200px",
								overflowY: "auto",
								padding: "10px",
								border: "1px solid #ccc",
								borderRadius: "4px",
								fontFamily: "monospace",
								fontSize: "14px",
								flexGrow: 0,
								width: "100%",
							}}
						>
							<pre>{subtitleContent}</pre>
						</Box>
					</Box>
				</>
			) : (
				<>
					<Typography margin={"10px 0px"} component={"p"}>
						Upload Subtitle File
					</Typography>
					<Button
						component="label"
						role={undefined}
						variant="contained"
						tabIndex={-1}
						sx={{ width: "100%", padding: "10px" }}
						startIcon={<UploadFileIcon />}
					>
						Upload file
						<VisuallyHiddenInput
							onChange={handleSubtitleFileChange}
							type="file"
							name={name}
							accept=".srt"
						/>
					</Button>
					<Typography fontSize={12} sx={{ color: "grey" }}>
						Select a valid file type: Subtitle files (.srt)
					</Typography>
				</>
			)}
		</Box>
	);
};

export default UploadSubtitleFile;
